import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en-us",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json" + "?cb=" + new Date().getTime(),
      requestOptions: {
        cache: "no-store",
      },
    },
    lowerCaseLng: true,
  });

export default i18n;
